import { render, staticRenderFns } from "./NosologyAdd.vue?vue&type=template&id=7080b895"
import script from "./NosologyAdd.vue?vue&type=script&lang=js"
export * from "./NosologyAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports